<template>
  <div class="relative flex flex-col min-w-0 break-words w-full">
    <div class="rounded-t mb-0 pb-3 border-0">
      <div class="flex flex-wrap items-center">
        <div class="relative w-full max-w-full flex-grow flex-1">
          <h3 class="text-3xl text-blueGray-700 font-headline mt-4 mx-5">
            Expert Scanner Configs
          </h3>
        </div>
      </div>
    </div>
    <DataTable
      class=""
      :admin-prefix="adminPrefix"
      :api-prefix="apiPrefix"
      :singular-label="singularLabel"
      :plural-label="pluralLabel"
      :columns="columns"
      :create-form="createForm"
      :update-form="updateForm"
      :actions="actions"
      :nested-level="0"
    />
  </div>
</template>
<script>
import DataTable from "./DataTable.vue";

export default {
  name: "ExpertScannerConfigs",
  components: {
    DataTable,
  },
  data() {
    return {
      singularLabel: "expert scanner config",
      pluralLabel: "expert scanner configs",
      adminPrefix: "expert-scanner-configs",
      apiPrefix: "expert-scanner-config",
      columns: {
        clientName: {
          type: "string",
          label: "Client Name",
          sort: { allow: true, default: null },
          filter: { allow: true, matchType: "wildcard", value: "" },
        },
        slug: {
          type: "string",
          label: "Slug",
          sort: { allow: true, default: null },
          filter: { allow: true, matchType: "wildcard", value: "" },
        },
        isActive: {
          type: "boolean",
          label: "Active",
          sort: { allow: true, default: null },
          filter: { allow: true, matchType: "wildcard", value: "" },
        },
        createdAt: {
          type: "absoluteDate",
          label: "Created At",
          sort: { allow: true, default: "desc" },
          filter: { allow: false },
        },
      },
      createForm: {
        clientName: {
          label: "Client Name:",
          placeholder: "e.g., Estée Lauder",
          type: "string",
          validatorTypes: ["required"],
        },
        slug: {
          label: "Slug:",
          placeholder: "e.g., estee-lauder",
          type: "string",
          validatorTypes: ["required"],
        },
        securityKey: {
          label: "Security Key:",
          placeholder: "Min 16 characters alphanumeric",
          type: "string",
          validatorTypes: ["required"],
        },
        headerTitle: {
          label: "Header Title:",
          type: "string",
          validatorTypes: ["required"],
          default: "Innovation Opportunity Scanner",
        },
        headerSubtitle: {
          label: "Header Subtitle:",
          type: "string",
          validatorTypes: ["required"],
          default:
            "Explore emerging research trends, whitespace opportunities, and available academic experts across any R&D challenge area",
        },
        searchLabel: {
          label: "Search Label:",
          type: "string",
          validatorTypes: ["required"],
          default: "Enter a research challenge or ingredient category",
        },
        searchPlaceholder: {
          label: "Search Placeholder:",
          type: "string",
          validatorTypes: ["required"],
          default: "e.g., biodegradable encapsulation for fragrance delivery",
        },
        quickPicks: {
          label: "Quick Picks (Comma Separated):",
          placeholder: "Topic 1, Topic 2, Topic 3",
          type: "string",
          formatFunction(val) {
            if (typeof val === "string") {
              return val.split(",").map((s) => s.trim());
            }
            return val;
          },
        },
        isActive: {
          label: "Active:",
          type: "boolean",
          default: true,
        },
        organization: {
          label: "Organization (Optional):",
          type: "autocomplete-select",
          idKey: "hashedId",
          labelKey: "name",
          autocompleteEndpoint: "organization",
          searchOnFocus: true,
        },
      },
      updateForm: {
        hashedId: { type: "hidden" },
        clientName: {
          label: "Client Name:",
          type: "string",
          validatorTypes: ["required"],
        },
        slug: {
          label: "Slug:",
          type: "string",
          validatorTypes: ["required"],
        },
        securityKey: {
          label: "Security Key:",
          type: "string",
          validatorTypes: ["required"],
        },
        headerTitle: {
          label: "Header Title:",
          type: "string",
          validatorTypes: ["required"],
        },
        headerSubtitle: {
          label: "Header Subtitle:",
          type: "string",
          validatorTypes: ["required"],
        },
        searchLabel: {
          label: "Search Label:",
          type: "string",
          validatorTypes: ["required"],
        },
        searchPlaceholder: {
          label: "Search Placeholder:",
          type: "string",
          validatorTypes: ["required"],
        },
        quickPicks: {
          label: "Quick Picks (Comma Separated):",
          type: "string",
          formatValue(row) {
            if (row.quickPicks) {
              return row.quickPicks.join(", ");
            }
            return "";
          },
          formatFunction(val) {
            if (typeof val === "string") {
              return val.split(",").map((s) => s.trim());
            }
            return val;
          },
        },
        isActive: {
          label: "Active:",
          type: "boolean",
        },
        organization: {
          label: "Organization (Optional):",
          type: "autocomplete-select",
          idKey: "hashedId",
          labelKey: "name",
          autocompleteEndpoint: "organization",
          searchOnFocus: true,
          formatValue(row) {
            if (row.organization) {
              return {
                hashedId: row.organization.hashedId,
                name: row.organization.name,
              };
            }
            return null;
          },
        },
      },
      actions: {
        linkToRecord: {
          allow: true,
          formatUrl(row) {
            return `${import.meta.env.VITE_CV_BASE_URL}/experts-for/${
              row.slug
            }/${row.securityKey}`;
          },
        },
        update: {
          allow: true,
        },
        delete: {
          allow: true,
        },
        menuItems: [],
      },
    };
  },
};
</script>
